"use strict";

/**************************
** BOTTOM DISCOVER BUTTON **
***************************/
var discoverBtn = document.querySelector('#js-open-discover'),
    discoverList = document.querySelector('#js-list-discover');
TweenMax.set(discoverList, {
  height: 0
});
discoverBtn.addEventListener('click', function () {
  discoverBtn.classList.toggle('open');

  if (discoverBtn.classList.contains('open')) {
    TweenMax.set(discoverList, {
      height: "auto"
    });
    TweenMax.from(discoverList, 1, {
      height: 0
    });
    setTimeout(function (_) {
      return scrollTo(document.body, document.body.clientHeight, 1000);
    }, 500);
  } else {
    TweenMax.to(discoverList, 1, {
      height: 0
    });
  }
}, false);

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

function scrollTo(element, to, duration) {
  var start = element.scrollTop,
      change = to - start,
      current = 0,
      increment = 20;

  var animateScroll = function animateScroll() {
    current += increment;
    var val = Math.easeInOutQuad(current, start, change, duration);
    element.scrollTop = val;

    if (current < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
}